import "./bazi-chart-style.scss";

//命盤表（八字命盤 / 大運共用）
//
//  兩者的結構完全一樣（欄標題 + 天干 + 地支 + 十神 + 十二長生），
//  差別只在欄位數與標題，所以用同一個元件吃不同資料，
//  不要為了「看起來是兩種東西」寫兩份。
//
//  五行顏色由資料帶的 element 決定，不在前端重算 ——
//  五行判定是命理演算的一部分，前後端各算一次就一定會有不同步的一天。
//
//  props:
//    data  { title, note, columns[] }
const BaziChart = ({ data }) => {
  if (!data) return null;
  const { title, note, columns = [] } = data;

  return (
    <section className="bz">
      <h3 className="bz__head">
        <svg className="bz__check" viewBox="0 0 24 24" width="15" height="15" aria-hidden="true">
          <path d="M4 12.5l5 5L20 6.5" stroke="currentColor" strokeWidth="2.6" fill="none" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
        <strong className="bz__title">{title}</strong>
        {note && <span className="bz__note">{note}</span>}
      </h3>

      <div
        className="bz__grid"
        //欄數由資料決定：八字四柱、大運三欄，版型不用各寫一份
        style={{ "--bz-cols": columns.length }}
      >
        {columns.map((col) => (
          <div
            className={col.current ? "bz__col is-current" : "bz__col"}
            key={col.key}
          >
            <span className="bz__col-head">{col.header}</span>

            {col.known ? (
              <>
                <span className={`bz__tile bz__tile--${col.gan.element}`}>
                  {col.gan.char}
                </span>
                <span className={`bz__tile bz__tile--${col.zhi.element}`}>
                  {col.zhi.char}
                </span>
                <span className="bz__god">{col.zhiGod}</span>
                <span className="bz__stage">{col.stage}</span>
              </>
            ) : (
              //時辰未知很常見（很多人只知道生日不知道時辰）。
              //用虛線空框而不是整欄不顯示 —— 讓人看得出「這裡缺一塊」，
              //之後才會想去補上出生時間。
              <>
                <span className="bz__tile bz__tile--unknown">?</span>
                <span className="bz__tile bz__tile--unknown">?</span>
                <span className="bz__god">-</span>
                <span className="bz__stage">-</span>
              </>
            )}
          </div>
        ))}
      </div>
    </section>
  );
};

export default BaziChart;
